import BaseApiService from './baseApiService';
import { CreateReportContractCommand, GetReportContractsVM } from '../contracts';

class ReportContractsApiService extends BaseApiService {
    loadReportContracts = (year: number, airlineCode: string) => {
        return this.get<GetReportContractsVM[]>('report-contracts', { params: { year, iataCode: airlineCode } });
    };

    createReportContract = (command: CreateReportContractCommand) => {
        return this.post<void, CreateReportContractCommand>('report-contracts', command);
    };
}

export default new ReportContractsApiService();
